<template>
  <div
    class="w-content grab border rounded-pill d-flex align-items-center p-2 m-2"
  >
    <div class="text-muted mx-1">{{ data.order }}</div>
    <div v-if="isDraggable" class="text-muted mx-1">
      <i class="fas fa-grip-vertical mx-1"></i>
    </div>
    <div
      class="dot rounded-circle mx-1"
      :style="{ backgroundColor: data.color }"
    ></div>
    <div class="font-weight-bold mx-1">{{ data.description }}</div>
    <div v-if="!readOnly" class="mx-1" @click="$emit('remove', data)">
      <i class="pointer far fa-times-circle text-danger"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionItem',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDraggable() {
      return !this.readOnly && this.draggable;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-content {
  width: fit-content;
}
.grab {
  cursor: grab;
}
.dot {
  width: 15px;
  height: 15px;
}
.pointer {
  cursor: pointer;
}
</style>
